import type { IconName } from '@tkww/orion-web-ds-graphic';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

interface PricingFactorCardProps {
	iconName: IconName;
	title: string;
	description: string;
}

export const PricingFactorCard = ({
	iconName,
	title,
	description,
}: PricingFactorCardProps) => {
	return (
		<div className={Styles.pricingFactorCard} data-testid="pricing-factor-card">
			<Icon size="md" name={iconName} aria-label={title} />
			<TextBody size="md" bold>
				{title}
			</TextBody>
			<TextBody size="sm" color="subtle-dark">
				{description}
			</TextBody>
		</div>
	);
};
